import React from "react";
import { Container, Image, Row, Col } from "react-bootstrap";

import logo_1 from "./../../assets/logos/ProlitigioLogo_1.svg";
import logo_3 from "./../../assets/logos/ProlitigioLogo_3.png";

const MainHeader = (props) => {
	return (
		<header className="main-header">
			<Container className="p-0">
				<div className="title-bar py-3">
					<h1 className="title-text prolitigio-font mobile-only">PROFESIONALES EN LITIGACIÓN ORAL S.C.</h1>
				</div>
				<Row className="p-0 justify-content-center">
					<Col xs={3} md={2} className="p-0">
						<div className="plg-logo">
							<Image src={logo_1} fluid />
						</div>
					</Col>
					<Col xs={1} className="mobile-only"></Col>
					<Col md={8} className="pc-only">
						<h1 className="title-text prolitigio-font pt-3">PROFESIONALES EN LITIGACIÓN ORAL S.C.</h1>
					</Col>
					<Col xs={3} md={2} className="p-0">
						<div className="box-logo">
							<Image src={logo_3} fluid />
						</div>
					</Col>
				</Row>
			</Container>
		</header>
	);
};

export default MainHeader;
